import DataTransferObject from '@/Communication/DataTransferObject';
import ComponentManager from '@/Management/ComponentManager';

export default class SupportPropertyDTO extends DataTransferObject {

    public SupportPDO_ID: number;

    public RemotePDO_ID: number;

    public IsEnumeration: boolean;

    public TypeName: string;

    public Name: string;

    public Value: object;


    constructor() {
        super({ xmlProperties: ['IsEnumeration', 'Name', 'RemotePDO_ID', 'SupportPDO_ID', 'TypeName', 'Value'], xmlNamespace: 'ISMS.DataTransfer' });

        this.SupportPDO_ID = this.defaultFromType('long');
        this.RemotePDO_ID = this.defaultFromType('long');
        this.IsEnumeration = this.defaultFromType('bool');
        this.TypeName = this.defaultFromType('string');
        this.Name = this.defaultFromType('string');
        this.Value = this.defaultFromType('object');
    }
}

ComponentManager.setModel('SupportPropertyDTO', SupportPropertyDTO, 'RADPresentation.HTMLClient.DefaultViewExtensions');